export const neverFunc = (input) => {
    throw new Error(`typecheck error, never encountered: ${input}`);
};
